module.exports = __webpack_public_path__ + "img/banner_bg.f3e895a8.png";